import { Alert } from "@/shared";

export function AdminUserAlert() {
  const messages = [
    "* 이미지 편집 시 실시간으로 처리됩니다. 삭제에 주의하세요.",
  ];
  return (
    <>
      <Alert messages={messages} />
    </>
  );
}
